import { ApiBaseFront } from "../../front/api-base-front";

export type PrintShopOrderDataPostRequest = {
  kijshopCd: string,
  shopOrderId: string,
  files: {
    filename: string,
    body: string,
    is_create: '0' | '1',
  }[]
};

export class ApiPrintShopOrderDataPost extends ApiBaseFront {
  constructor(param: PrintShopOrderDataPostRequest) {
    const {
      kijshopCd,
      shopOrderId,
      ..._param
    } = param;
  
    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}`,
      'JSON',
      _param,
    );
  }
}

export type PrintShopOrderDataGetResponse = {
  path: string,
  jsonList: {
    filename: string,
    body: string,
  }[],
};

export class ApiPrintShopOrderDataGet extends ApiBaseFront<PrintShopOrderDataGetResponse> {
  constructor(param: { kijshopCd: string, shopOrderId: string }) {
    const { kijshopCd, shopOrderId } = param;
    super(
      'GET',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}`,
      'JSON',
      {}
    );
  }
}

export class ApiPrintShopOrderDataDelete extends ApiBaseFront {
  constructor(param: { kijshopCd: string, shopOrderId: string }) {
    const { kijshopCd, shopOrderId } = param;
    super(
      'DELETE',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}`,
      'JSON',
      {}
    );
  }
}

export class ApiPrintShopOrderDelete extends ApiBaseFront {
  constructor(param: { kijshopCd: string, shopOrderId: string, path: string[] }) {
    const { kijshopCd, shopOrderId } = param;
    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}`,
      'JSON',
      {
        path: param.path
      },
    );
  }
}
